//TODO : Refactor after ai
import type { HTMLAttributes, ReactNode } from "react";
import { InputField } from "./primitives";

export interface OverviewToolbarProps extends HTMLAttributes<HTMLDivElement> {
  query?: string;
  onQueryChange?: (value: string) => void;
  searchPlaceholder?: string;
  filters?: ReactNode;
  sort?: ReactNode;
  viewSwitcher?: ReactNode;
  actions?: ReactNode;
  /** The FILTERED count — the user needs to see what their filters cut. */
  count?: number;
  countLabel?: string;
}

/** Search, filters, sort and view switch above a collection. */
export function OverviewToolbar({
  query,
  onQueryChange,
  searchPlaceholder = "Suchen",
  filters,
  sort,
  viewSwitcher,
  actions,
  count,
  countLabel,
  className = "",
  ...rest
}: OverviewToolbarProps) {
  return (
    <div
      className={className}
      style={{ display: "flex", flexDirection: "column", gap: 12 }}
      {...rest}
    >
      <div className="bui-ov-toolbar">
        {onQueryChange && (
          <div style={{ width: 260, flexShrink: 0 }}>
            <InputField
              size="sm"
              placeholder={searchPlaceholder}
              value={query}
              onChange={(event) => onQueryChange(event.target.value)}
              leadingIcon={
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
                  <circle cx="11" cy="11" r="7" />
                  <path d="m20 20-3.5-3.5" />
                </svg>
              }
            />
          </div>
        )}
        {count != null && (
          <span
            style={{
              font: "var(--t-paragraph-s)",
              color: "var(--text-tertiary)",
              whiteSpace: "nowrap",
            }}
          >
            {count} {countLabel}
          </span>
        )}
        <span className="bui-ov-toolbar__spacer" />
        {sort}
        {actions}
        {viewSwitcher}
      </div>
      {filters}
    </div>
  );
}
